import React from "react";

export default function BookingCalculation({
  isTable,
  availabilityMeta,
  checkError,
  soldOutRangeMessage,
  submitError,
  submitOk,
}) {
  return (
    <>
      {checkError ? <p className="booking-error">{checkError}</p> : null}
      {!checkError && soldOutRangeMessage ? <p className="booking-error">{soldOutRangeMessage}</p> : null}
      {isTable && availabilityMeta ? <p className="booking-meta">{availabilityMeta}</p> : null}
      {submitError ? <p className="booking-error">{submitError}</p> : null}
      {submitOk ? <p className="booking-success">{submitOk}</p> : null}
    </>
  );
}
